import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GlobalLoaderComponent } from "./shared/components/global-loader/global-loader.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterModule,
    GlobalLoaderComponent
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'EDIVerse';
}

